<template>
    <transition>
        <v-flex :class="attributes.width">
            <BnHelpField :name="attributes.mezo" :active="!!attributes.help" :prefix="!!attributes.forgalmiBetukod">
                <v-text-field
                        :style="getStyle()"
                        color="secondaryButtonColor"
                        slot="two"
                        @focus="focus()"
                        :label="attributes.label"
                        :disabled="!isEditable()"
                        v-model="inputVal"
                        v-bnmask="attributes.mask"
                        :hint="getPersistentHint"
                        @keyup="onKeyUp()"
                        persistent-hint
                        persistent-placeholder
                        clearable
                        :counter="attributes.counter"
                        :path="attributes.path"
                        :suffix="attributes.suffix"
                        @blur="blurFn()"
                        @change="irszamChange()"
                        :prefix="attributes.prefix"
                        :ref="attributes.mezo"
                        :id="attributes.mezo + '-input'"
                        :attributes="attributes"
                        :afterDatePath="attributes.afterDatePath"
                        :beforeDatePath="attributes.beforeDatePath"
                        :append-icon="attributes.innerIcon"
                        @click:clear="clearFn"
                        @keydown="keyDownFn($event)"
                        @keypress="keyDownFn($event)"
                        :outlined="cfg.props.outlined"
                        placeholder="  "
                />
            </BnHelpField>
        </v-flex>
    </transition>
</template>

<script>
import storeValueByPath from '../../mixins/StoreValueByPath';
import bnFormField from '../../mixins/bnFormField';

export default {
    name: 'BnIrszam',
    mixins: [storeValueByPath, bnFormField],

    methods: {
        irszamChange() {
            this.$emit('change');
        },
    },
};
</script>

<style scoped>

</style>
